import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {Auth} from '../../providers/auth';
import 'rxjs/add/operator/debounceTime';
import {Subject} from 'rxjs/Subject';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-recuperar',
  templateUrl: './recuperar.component.html',
  styleUrls: ['./recuperar.component.css']
})
export class RecuperarComponent implements OnInit {

  constructor(private router: Router,
              private spinner: NgxSpinnerService,
              private auth: Auth,
              private fb: FormBuilder) {
  }

  private _success = new Subject<string>();
  successMessage: string;
  alertType = 'danger';
  pending = false;

  form: FormGroup;

  recuperar() {
    if (this.pending) return;
    if (this.form.invalid) {
      return;
    }
    this.pending = true;
    this.spinner.show();
    this.auth.recoveryPass(this.form.get('email').value).subscribe((res: any) => {
      this.spinner.hide();
      this.pending = false;
      this.alertType = 'success';
      this._success.next(res && res.message
        ? res.message
        : 'Se ha enviado un link a su correo para recuperar su contraseña');
      this.form.reset();
      setTimeout(() => this.router.navigate(['login']), 3000);
    }, err => {
      console.error('ERROR', err);
      this.spinner.hide();
      this.pending = false;
      this.alertType = 'danger';
      this._success.next(err.error && err.error.message
        ? err.error.message
        : 'Error al enviar el correo. Intente nuevamente.');
    });
  }

  irALogin() {
    this.router.navigate(['login']);
  }

  onKeydown(event) {
    if (event.key === 'Enter') {
      this.recuperar();
    }
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });

    this._success.subscribe((message) => this.successMessage = message);
    this._success.debounceTime(10000).subscribe(() => this.successMessage = null);
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/recuperar/recuperar.component.ts